import React from 'react';
import { Skeleton, Text } from '@/components/ui';

interface IdCellProps {
  value?: unknown;
  render?: () => React.ReactNode;
  size?: 'small' | 'medium' | 'large';
}

function IdCell({ value, render, size = 'small' }: IdCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  const displayValue = String(value || '');

  // Determine text size based on size prop
  const textSize = size === 'small' ? '1' : size === 'large' ? '3' : '2';

  return (
    <Text size={textSize} className="data-cell__id" title={displayValue}>
      {displayValue}
    </Text>
  );
}

export function IdCellSkeleton() {
  return (
    <Skeleton
      style={{
        width: '40px',
        height: '14px',
        borderRadius: '4px',
        margin: '0 auto',
      }}
    />
  );
}

export default IdCell;
